import Component from './TosModal'

export default Component
